import { useAuth } from '../contexts/AuthContext';

/**
 * Can — conditionally render in-page content based on a permission.
 * Use to hide buttons / sections a user lacks. Pass `permission` for a
 * single key or `anyOf` for a list. `fallback` renders when not allowed.
 *
 * Note: the backend independently enforces every permission — this is a
 * UX layer only.
 */
export default function Can({ permission, anyOf, fallback = null, children }) {
  const { can, canAny } = useAuth();
  const allowed = anyOf
    ? canAny(anyOf)
    : permission
      ? can(permission)
      : true;
  return allowed ? children : fallback;
}
